import {useDispatch} from 'react-redux'
import {TableList} from '../../Components/TableList/TableList'
import {setDestinationView} from '../../Store/InterfaceSlice'
import {type EnrichedCertificate} from '../../Store/DataSlice'
import {useLocalization} from '../../Hooks/useLocalization'
import {toBelgianDate} from '../../Utils/Formatting'

interface CertificateListProps {
    certificates: EnrichedCertificate[]
    isLoading: boolean
}

export function CertificateList({
                                    certificates,
                                    isLoading,
                                }: CertificateListProps) {
    const dispatch = useDispatch()
    const certificateStatusesLocalization = useLocalization(
        'certificate-statuses'
    )

    return (
        <TableList
            tableType="certificate"
            items={certificates}
            configurations={{
                uuid: {
                    label: 'Uuid',
                    show: false,
                },
                certificateNumber: {
                    label: 'Certificaat nummer',
                    show: true,
                },
                naceCodes: {
                    label: 'NACE codes',
                    show: false,
                    getCsvExportValue: (value) =>
                        value != null ? (value as string[]).join(',') : '',
                    getExcelExportValue: (value) =>
                        value != null ? (value as string[]).join(',') : '',
                },
                companyBranches: {
                    label: 'companyBranches',
                    show: false,
                },
                companyNames: {
                    label: 'Onderneming(en)',
                    show: true,
                },
                companyVatNumbers: {
                    label: 'Onderneming nummer(s)',
                    show: false,
                },
                companyPostcodes: {
                    label: 'Onderneming postcodes',
                    show: false,
                },
                isGroupCertificate: {
                    label: 'Is groep certificaat',
                    show: false,
                    getValue: (value) => ((value as boolean) ? '✔️' : '❌'),
                },
                certificateInstanceName: {
                    label: 'Certificaat instantie',
                    show: true,
                },
                certificateInstanceVatNumber: {
                    label: 'Certificaat instantie',
                    show: false,
                },
                calculatedStatus: {
                    label: 'Status',
                    show: true,
                    getValue: (value) =>
                        certificateStatusesLocalization.text(
                            value as string,
                            value as string
                        ),
                },
                status: {
                    label: 'Status',
                    show: false,
                },
                issueDate: {
                    label: 'Uitgave datum',
                    show: false,
                    getValue: (value) => toBelgianDate(value as number),
                    getCsvExportValue: (value) =>
                        value != null ? new Date(value as number).toISOString() : '',
                    getExcelExportValue: (value) =>
                        value != null ? new Date(value as number) : undefined,
                },
                validFrom: {
                    label: 'Geldig van',
                    show: false,
                    getValue: (value) => toBelgianDate(value as number),
                    getCsvExportValue: (value) =>
                        value != null ? new Date(value as number).toISOString() : '',
                    getExcelExportValue: (value) =>
                        value != null ? new Date(value as number) : undefined,
                },
                validUntil: {
                    label: 'Geldig tot',
                    show: true,
                    getValue: (value) => toBelgianDate(value as number),
                    getCsvExportValue: (value) =>
                        value != null ? new Date(value as number).toISOString() : '',
                    getExcelExportValue: (value) =>
                        value != null ? new Date(value as number) : undefined,
                },
                extendedUntil: {
                    label: 'Verlengd tot',
                    show: false,
                    getValue: (value) => toBelgianDate(value as number),
                    getCsvExportValue: (value) =>
                        value != null ? new Date(value as number).toISOString() : '',
                    getExcelExportValue: (value) =>
                        value != null ? new Date(value as number) : undefined,
                },
                type: {
                    label: 'Type',
                    show: true,
                },
                scope: {
                    label: 'Scope',
                    show: true,
                    getElementValue: (value) => {
                        return (
                            <span className="overflow-limited-text" title={value as string}>
                {value as string}
              </span>
                        )
                    },
                },
                deniedPeriods: {
                    label: 'Denied periods',
                    show: false,
                },
                suspendedFrom: {
                    label: 'Suspended from',
                    show: false,
                },
                withdrawnFrom: {
                    label: 'Withdrawn from',
                    show: false,
                },
            }}
            localizationSection={'certificate'}
            getUniqueKey={(item) => item.uuid}
            onRowClick={(item) =>
                dispatch(
                    setDestinationView({
                        destinationView: 'certificate-detail',
                        detailKey: item.uuid,
                    })
                )
            }
            isLoading={isLoading}
        />
    )
}
